<template>
  <div>
    <label for="inputFirstName">{{ $t('questionForm.firstName.title') }}</label>
    <v-text-field
      id="inputFirstName"
      v-model="firstName"
      solo
      flat
      hide-details="auto"
      :class="{
        'is-valid':
          !disabled &&
          firstName &&
          firstName.length &&
          $v.firstName.$dirty &&
          !$v.firstName.$invalid
      }"
      :error="!disabled && $v.firstName.$error"
      :error-messages="$v.firstName.$error ? $t('questionForm.firstName.errorText') : ''"
      :placeholder="placeholder || ''"
      :disabled="disabled"
      :messages="$t('questionForm.firstName.helpTextRealData')"
      @click="sendGtmEvent('Jméno')"
      @blur="$v.firstName.$dirty || (firstName && firstName.length) ? $v.firstName.$touch() : null"
    >
      <template v-if="!disabled" #append>
        <v-icon v-if="firstName && firstName.length && $v.firstName.$dirty && !$v.firstName.$error">
          $tick
        </v-icon>
        <v-icon v-if="$v.firstName.$error"> $warning </v-icon>
      </template>
    </v-text-field>
  </div>
</template>

<script>
import formValidation from '@/mixins/formValidation';
import formGtm from '@/mixins/formGtm';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'FirstName',
  mixins: [formValidation, formGtm],
  props: {
    placeholder: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    firstName: {
      get() {
        return this.$store.state.forms.firstName.firstName;
      },
      set(value) {
        this.$store.commit('forms/firstName/updateFirstName', value);
      }
    }
  },
  validations() {
    let validation = { firstName: {} };
    if (this.required) {
      validation.firstName = { required };
    }
    return validation;
  },
  created() {
    this.$eventHub.$on('validateFirstName', done => this.validateForm(done, 'forms/firstName'));
  },
  destroyed() {
    this.$eventHub.$off('validateFirstName');
  }
};
</script>
